module.exports = __webpack_public_path__ + "static/media/N9.6f1facfd.jpg";